import Vue from 'vue';

import VuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor';
import FormGroup from '../components/base/FormGroup';

Vue.use(VuelidateErrorExtractor, {
  template: templates.singleErrorExtractor.foundaton6,
  i18n: 'validations'
});

Vue.component('FormGroup', FormGroup);
